export const REQUEST_SEARCH_DATA = "REQUEST_SEARCH_DATA";
export const SET_SEARCH_DATA = "SET_SEARCH_DATA";
export const REQUEST_SEARCH_DATA_ERROR = "REQUEST_SEARCH_DATA_ERROR";
export const REQUEST_SEARCH_PAGE = "REQUEST_SEARCH_PAGE";

export const REQUEST_SEARCH = "REQUEST_SEARCH";
export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
export const SET_SEARCH_ERROR = "SET_SEARCH_ERROR";
